import React, { useState, useEffect, useRef, useContext } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ViewBox from "./components/ViewBox";
import Points from "./components/Points";
import SVG from "./components/SVG";
import "./App.css";
import "normalize.css";
import { AppContext } from "./components/AppProvider";
import CSSValue from "./components/CSSValue";

function App() {
  const ctx = useContext(AppContext);
  // const ref = useRef();

  const [path, setPath] = useState(`M 10,30
  A 20,20 0,0,1 50,30
  A 20,20 0,0,1 90,30
  Q 90,60 50,90
  Q 10,60 10,30 z`);

  useEffect(() => {
    let pathDom = window.document.querySelector("path");
    let len = pathDom.getTotalLength();
    let points = [];

    for (let i = 0; i < ctx.numPoints; i++) {
      const pt = pathDom.getPointAtLength((i * len) / (ctx.numPoints - 1));
      points.push([`${pt.x}% ${pt.y}%`]);
    }
    points = points.join(", ");
    points = `polygon(${points})`;
    ctx.pointsChangeHandler(points);
    return () => {
      // cleanup
    };
  }, [ctx.numPoints, path]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Header />
      <main
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            border: "1px dotted black",
            borderRadius: "10px",
            padding: "1em",
            margin: "1em",
            width: "85%",
          }}
        >
          <div
            tyle={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p style={{ marginTop: "0" }}>Enter SVG path: </p>
            <input
              type="text"
              name="path"
              onChange={(e) => setPath(e.target.value)}
              value={path}
            ></input>
          </div>
          <ViewBox />
        </div>
        <div className="container">
          <SVG path={path} />
          <Points />
        </div>
        <div style={{ display: "flex" }}>
          <p>Enter number of points: </p>
          <input
            type="number"
            name="numPoints"
            min="1"
            max="1000"
            onChange={(e) => ctx.numPointsChangeHandler(e.target.value)}
            value={ctx.numPoints}
          ></input>
        </div>
        <CSSValue points={ctx.points} />
      </main>
      <Footer />
    </div>
  );
}

export default App;
